import { DATE_ISO } from '@/js/libs/api-helpers';
import dayjs from '@/js/libs/dayjs';

import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import type { PayoutsRouteParams } from './types.ts';

const DATE_REG_EXP = /^\d{4}-\d{2}-\d{2}$/;

export const validatePayoutDate: ParamsValidator<Required<PayoutsRouteParams>> = ({ date }) => DATE_REG_EXP.test(date);

export const getFirstDayOfCurrentMonth = () => {
  const firstDayOfMonth = dayjs().date(1).format(DATE_ISO);

  return firstDayOfMonth;
};
